
//const colors = ['rgb(255, 83, 73)','rgb(87, 203, 244)','rgb(244,87,125)','rgb(87,125,244)','rgb(73, 255, 174)'];
const colors = ['#3b82f6','#0ea5e9','#06b6d4','#6366f1', '#8b5cf6', '#64748b', '#14b8a6', '#10b981','#d946ef' , '#ec4899'];


const getColor = (num) => {
  return colors[num % colors.length];
}

const getColors = (num=null) => {
  
  if(num == null){
    return colors;
  } 
  else {
    let options = [];
    for(let i = 0; i < num; i++){
      options.push(getColor(i));
    }
    return options;
  }
}

const getColorForOriginal = () => {
  return "#888888"
}

const formatDate = (date, form, separator) => {
  const format = (dt) => {
    let f = new Intl.DateTimeFormat('en-US', dt)
    return f.format(date);
  }
  return form.map(format).join(separator);
}

const toFactDate = (date) => {
  return formatDate(date, [{year: 'numeric'}, {month: '2-digit'},{day: '2-digit'}], '');
}
const fromFactDate = (date)=> {
  if (date == null || date.length < 8) { return null}
  return new Date(date.slice(0,4), (date.slice(4,6) - 1), date.slice(6,8))
}

const toDisplayDate = (date) => {
  //console.log('date',date)
  if(date == null || date.length < 8) { return null}
  date = date +''
  let dt = new Date(date.slice(0,4), (date.slice(4,6) - 1), date.slice(6,8));
  return new Intl.DateTimeFormat(undefined,{month:'short',day:'2-digit'}).format(dt);
}

const getFactDateRange = (start, end) => {
  //console.log('getFactDateRange:', start, ':', end);
  if(start == null || end == null || start > end) {
    return null;
  }

  let dates = [];
  //let factDates=[];

  let curr = start;
  let currDate = fromFactDate(curr);
  while(curr <= end){
    //factDates.push(curr);
    //dates.push(currDate);
    //console.log(curr, ":", currDate);
    //had to wrap in new date because the date was getting passed by reference instead of value
    dates.push({factDate:curr, date: new Date(currDate)});
    currDate.setDate(currDate.getDate() + 1);
    curr = toFactDate(currDate);
  }
  //console.log(dates);
  /*
  return {
    factDates: factDates,
    dates: dates
  };*/
  return dates;
}

const alterDate = (date, diff) => {
  let dt = new Date(date);
  dt.setDate(dt.getDate() + diff);
  return dt;
}

const isFactDate = (date) => {
  return (date != null && date.length === 8 && !isNaN(date))
}

const toShortDateTimeDisplayFromStr = (dateStr) => {
  //console.log('toShortDateTimeDisplayFromStr: ',dateStr)
  if(dateStr == null) { return null}
  //console.log('date', dateStr);
  //let dt = new Date(dateStr);
  let els = dateStr.split(/[^0-9]/);
  let dt = new Date(els[0], els[1]-1, els[2], els[3], els[4], els[5]);
  //console.log('dt', dt);
  //return new Intl.DateTimeFormat(undefined,{dateStyle: 'short', timeStyle: 'medium'}).format(dt);
  //return new Intl.DateTimeFormat(undefined,{year:'numeric', month: '2-digit', day: '2-digit', hour: '2-digit',minute: '2-digit',second: '2-digit'}).format(dt);
  return new Intl.DateTimeFormat(undefined,{year:'numeric', month: 'numeric', day: 'numeric', hour: 'numeric',minute: '2-digit',second: '2-digit'}).format(dt);

}

const toDurationFormat = (duration) => {
  if(duration != null) {
    let mins = Math.floor(duration / 60);
    let secs = duration.toFixed() - (mins * 60);
    return (mins < 10 ? '0' + mins : mins) + ':' + (secs < 10 ? '0' + secs : secs);
  }
  return null;
}

const toPercent = (number, decimal) => {
  number *= 100;
  return number.toFixed(decimal);
  //return Number(Math.round(number + "e" + decimal) + "e-" + decimal);
}

const roundNum = (number, decimal) => {
  if(number != null) {
    return Number(number).toFixed(decimal);
  }
  return null;
}

const truncate = (str, len) => {
  if(str == null || str.length <= len) {
    return str;
  }
  return str.slice(0,len-3) + '...';
}

const maskString = (str, showLen, maskLen=0, mask="*") => {
  if(str == null || str.length <= showLen) {
    return str;
  }
  maskLen = maskLen < 1 ? str.length - showLen : maskLen;
  let maskedStr = str.slice(0,showLen); 
  for (let i = 0; i < maskLen; i++){
    maskedStr += mask;
  }
  return maskedStr;
}
export {getColor, toFactDate, fromFactDate, getFactDateRange, toDisplayDate, alterDate, isFactDate,
        toShortDateTimeDisplayFromStr, toDurationFormat, toPercent, roundNum, truncate, getColors,
        maskString, getColorForOriginal}
